import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";
import styles from "./CustomerSegmentation.module.scss";

const CustomerSegmentation = () => {
  const tableData = [
    { segmentName: 'High Spenders', customerCount: '300', avgSpend: '$1,000', desc: 'Customers with high average spend' },
    { segmentName: 'Frequent Buyers', customerCount: '300', avgSpend: '$500', desc: 'Customers who make frequent purchases' },
    { segmentName: 'Recent Customers', customerCount: '300', avgSpend: '$250', desc: 'Customers who joined in the last month' },
    { segmentName: 'Inactive Customers', customerCount: '300', avgSpend: '$100', desc: `Customers who haven't purchased recently` },
    { segmentName: 'Loyal Customers', customerCount: '300', avgSpend: '$750', desc: 'Customers with high loyalty program points' },
  ];

  const columns = [
    {
      name: "Segment Name",
      selector: (row) => row.segmentName,
      minWidth: "160px",
    },
    {
      name: "Customer Count",
      selector: (row) => row.customerCount,
      minWidth: "160px",
    },
    {
      name: "Average Spend",
      selector: (row) => row.avgSpend,
      minWidth: "160px",
    },
    {
      name: "Description",
      selector: (row) => row.desc,
      grow: 2,
      minWidth: "160px",
    },
    {
      name: "Action",
      cell: () => (
        <div className="d-flex gap-2">
          <button className={styles["action-button"]}>View</button>
          <button className={styles["action-button"]}>Edit</button>
        </div>
      ),
      minWidth: "120px",
    },
  ];

  return (
    <div className={styles["wrapper"]}>
      <DatatableComponent
        data={tableData}
        columns={columns}
        type="yellow-bordered"
        pagination
      />
    </div>
  );
};

export default CustomerSegmentation;